import { request } from './client';
import type { AuditLogResponse, AuditFilters } from '../types';

export const auditApi = {
  async getLogs(
    boardId: string,
    options?: { category?: string; action?: string; limit?: number; offset?: number }
  ): Promise<AuditLogResponse> {
    const params = new URLSearchParams();
    if (options?.category) params.set('category', options.category);
    if (options?.action) params.set('action', options.action);
    if (options?.limit) params.set('limit', options.limit.toString());
    if (options?.offset) params.set('offset', options.offset.toString());

    const queryString = params.toString();
    const url = `/api/squareup/boards/${boardId}/audit${queryString ? `?${queryString}` : ''}`;
    return request<AuditLogResponse>(url);
  },

  async getFilters(boardId: string): Promise<AuditFilters> {
    return request<AuditFilters>(`/api/squareup/boards/${boardId}/audit/filters`);
  },
};
